export const AGRICULTURAL_EVENT_CATEGORIES = [
  {
    code: "irrigation",
    labelKey: "agri_category_irrigation",
    icon: "Droplets",
    color: "#1976d2",
    softColor: "#e8f2ff",
  },
  {
    code: "rain",
    labelKey: "agri_category_rain",
    icon: "CloudRain",
    color: "#87ceeb",
    softColor: "#e5f6fd",
  },
  {
    code: "soil_preparation",
    labelKey: "agri_category_soil_preparation",
    icon: "Tractor",
    color: "#795548",
    softColor: "#f4ece8",
  },
  {
    code: "sowing_planting",
    labelKey: "agri_category_sowing_planting",
    icon: "Sprout",
    color: "#2e7d32",
    softColor: "#eaf6eb",
  },
  {
    code: "fertilization",
    labelKey: "agri_category_fertilization",
    icon: "FlaskConical",
    color: "#b7791f",
    softColor: "#fff6df",
  },
  {
    code: "crop_protection",
    labelKey: "agri_category_crop_protection",
    icon: "ShieldCheck",
    color: "#d84315",
    softColor: "#fff0eb",
  },
  {
    code: "crop_maintenance",
    labelKey: "agri_category_crop_maintenance",
    icon: "Scissors",
    color: "#7b1fa2",
    softColor: "#f6eafa",
  },
  {
    code: "observation_analysis",
    labelKey: "agri_category_observation_analysis",
    icon: "ScanSearch",
    color: "#3949ab",
    softColor: "#edf0ff",
  },
  {
    code: "harvest_postharvest",
    labelKey: "agri_category_harvest_postharvest",
    icon: "Wheat",
    color: "#9a6b00",
    softColor: "#fff7dc",
  },
  {
    code: "machinery_maintenance",
    labelKey: "agri_category_machinery_maintenance",
    icon: "Wrench",
    color: "#546e7a",
    softColor: "#edf2f4",
  },
  {
    code: "labor_task",
    labelKey: "agri_category_labor_task",
    icon: "Users",
    color: "#00897b",
    softColor: "#e6f6f3",
  },
  {
    code: "incident_alert",
    labelKey: "agri_category_incident_alert",
    icon: "TriangleAlert",
    color: "#c62828",
    softColor: "#fdecec",
  },
  {
    code: "other",
    labelKey: "agri_category_other",
    icon: "NotebookPen",
    color: "#616161",
    softColor: "#f1f2f3",
  },
];

export const getAgriculturalCategory = (code, event) => {
  let resolvedCode = code;
  if (!resolvedCode && event) {
    const title = String(event.title || "").toLowerCase();
    if (event.source === "rain" || title.includes("rain"))
      resolvedCode = "rain";
    else if (title.includes("irrigation") || event.dose || event.time)
      resolvedCode = "irrigation";
  }
  return (
    AGRICULTURAL_EVENT_CATEGORIES.find((item) => item.code === resolvedCode) ||
    AGRICULTURAL_EVENT_CATEGORIES[12]
  );
};

export const getEventTitle = (event, t) => {
  if (
    event?.title &&
    ![
      "manual Event",
      "Rain Event",
      "rain",
      "Irrigation recommendation",
    ].includes(event.title)
  ) {
    return event.title;
  }
  if (event?.title === "Irrigation recommendation")
    return t("irrigation_recommendation");
  const category = getAgriculturalCategory(event?.category_code, event);
  return t(category.labelKey);
};

export const parseEventDetails = (details) => {
  if (!details) return {};
  if (typeof details === "object") return details;
  try {
    return JSON.parse(details);
  } catch (_error) {
    return {};
  }
};

const trimDuration = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return "";
  return Number.isInteger(number) ? String(number) : String(Number(number.toFixed(2)));
};

export const getEventDurationLabel = (event, t) => {
  const details = parseEventDetails(event?.details);
  const unit = details.duration_unit === "hours" ? "hours" : "minutes";
  const selectedValue = details.duration;

  if (selectedValue !== undefined && selectedValue !== null && selectedValue !== "") {
    return unit === "hours"
      ? `${trimDuration(selectedValue)} ${t("agri_duration_hours_short", "h")}`
      : `${trimDuration(selectedValue)} ${t("agri_duration_minutes_short", "min")}`;
  }

  const minutes = Number(event?.time || 0);
  if (!Number.isFinite(minutes) || minutes <= 0) return `0 ${t("agri_duration_minutes_short", "min")}`;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = Math.round(minutes % 60);
  return hours > 0
    ? `${hours} ${t("agri_duration_hours_short", "h")} ${remainingMinutes} ${t("agri_duration_minutes_short", "min")}`
    : `${remainingMinutes} ${t("agri_duration_minutes_short", "min")}`;
};

export const isWaterEvent = (event) => {
  const category = getAgriculturalCategory(event?.category_code, event);
  return category.code === "irrigation" || category.code === "rain";
};

export const getRainSourceLabel = (event, t) => {
  if (getAgriculturalCategory(event?.category_code, event).code !== "rain") return null;
  return event.source === "manual"
    ? t("rain_source_manual", "Pluie saisie manuellement")
    : t("rain_source_weather", "Pluie météo estimée/prévue");
};

export const getEventColors = (event) => {
  const category = getAgriculturalCategory(event?.category_code, event);
  if (category.code === "rain") return { backgroundColor: "#87ceeb", color: "#17324d" };
  if (event?.status === "refused") return { backgroundColor: "#c62828", color: "#fff" };
  if (event?.source === "recommendation") {
    return { backgroundColor: event.status === "validated" ? "#137a56" : "#191970", color: "#fff" };
  }
  return { backgroundColor: category.color, color: "#fff" };
};

export const getRainAmountLabel = (event, t) => (
  event?.source === "rain" && parseEventDetails(event.details).rainfall_basis !== "total"
    ? t("rain_effective_amount", "Pluie utile")
    : t("dose")
);
